import { APIBasePath } from "../../config/paths";
const baseURL = APIBasePath + "stats/";
const DashboardURLs = {
  searchTickers: baseURL + "autocomplete",
  getSentimentGraphData: baseURL + "sentiments",
  getMentionsGraphData: baseURL + "mentions",
};

export default DashboardURLs;
